export default {
  name: 'OldBookQuickDrawer',
  props: {
    booth: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: 'public' // 'public' | 'owner'
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close', 'edit', 'detail'],
  data() {
    return {
      activeImage: null,
      activeKey: null,
      showZoomModal: false,
      zoomScale: 1,
      zoomPanX: 0,
      zoomPanY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      toolbarHidden: false,
      toolbarTimer: null
    };
  },
  watch: {
    booth: {
      handler(newBooth) {
        if (newBooth) {
          const isValid = (img) => img && typeof img === 'string' && img.trim() !== '' && img.trim() !== 'null' && img.trim().length > 5;
          if (newBooth.books && newBooth.books.length > 0 && isValid(newBooth.books[0].cover)) {
            this.activeImage = newBooth.books[0].cover;
            this.activeKey = 'book_0_cover';
          } else if (newBooth.books && newBooth.books.length > 0 && isValid(newBooth.books[0].coverBack)) {
            this.activeImage = newBooth.books[0].coverBack;
            this.activeKey = 'book_0_coverBack';
          } else if (isValid(newBooth.coverImage)) {
            this.activeImage = newBooth.coverImage;
            this.activeKey = 'coverImage';
          } else if (isValid(newBooth.stackImage)) {
            this.activeImage = newBooth.stackImage;
            this.activeKey = 'stack';
          } else {
            this.activeImage = null;
            this.activeKey = null;
          }
        } else {
          this.activeImage = null;
          this.activeKey = null;
          this.closeZoomModal();
        }
      },
      immediate: true
    },
    showZoomModal(val) {
      if (val) {
        window.addEventListener('keydown', this.handleKeyDown);
      } else {
        window.removeEventListener('keydown', this.handleKeyDown);
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  computed: {
    currentUserId() {
      try {
        const raw = localStorage.getItem('current-account');
        if (raw) {
          const acc = JSON.parse(raw);
          return acc.id || acc.userId || null;
        }
      } catch (e) {
        // ignore
      }
      return null;
    },
    isMyBooth() {
      if (!this.booth) return false;
      if (this.booth.isMyBooth === true) return true;
      if (this.currentUserId && this.booth.createBy && String(this.currentUserId) === String(this.booth.createBy)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    selectBookThumb(img, key) {
      if (img) {
        this.activeImage = img;
        this.activeKey = key;
      }
    },
    handleClose() {
      this.$emit('close');
    },
    handleGoToDetail() {
      if (!this.booth) return;
      this.$emit('detail', this.booth.id);
      this.$router.push('/old-books/' + this.booth.id);
      this.handleClose();
    },
    handleEdit() {
      if (!this.booth) return;
      this.$emit('edit', this.booth);
      this.$router.push('/old-book-form/' + this.booth.id);
      this.handleClose();
    },
    handleAddToCart() {
      if (!this.booth) return;
      if (this.isMyBooth) {
        this.$toast.warning('Bạn không thể tự mua gian hàng sách của chính mình!');
        return;
      }
      const item = {
        id: `booth_${this.booth.id}`,
        boothId: this.booth.id,
        boothName: this.booth.name,
        sellerId: this.booth.createBy,
        sellerName: this.booth.createByName,
        saleType: this.booth.saleType,
        type: this.booth.saleType === 1 ? 'COMBO' : 'BOOTH',
        name: this.booth.name,
        cover:
          this.booth.stackImage ||
          this.booth.coverImage ||
          (this.booth.books && this.booth.books[0] && this.booth.books[0].cover),
        price: this.booth.price,
        weight: this.booth.weight || 350,
        totalBooks: this.booth.totalBooks,
        perStatus: this.booth.books && this.booth.books.length === 1 ? this.booth.books[0].perStatus : null,
        verStatus: this.booth.books && this.booth.books.length === 1 ? this.booth.books[0].verStatus : null
      };
      this.$store.dispatch('cart/addToCart', { item, openDrawer: true });
      this.handleClose();
      this.$toast.success(`Đã thêm "${this.booth.name}" vào giỏ hàng!`);
    },
    clampNum(value, min, max) {
      return Math.min(Math.max(value, min), max);
    },
    openZoomModal(img) {
      if (img && typeof img === 'string') {
        this.activeImage = img;
      }
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.toolbarHidden = false;
      this.showZoomModal = true;
    },
    closeZoomModal() {
      this.showZoomModal = false;
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.isDragging = false;
    },
    zoomIn() {
      this.zoomScale = this.clampNum(Number((this.zoomScale + 0.25).toFixed(2)), 0.5, 4);
    },
    zoomOut() {
      this.zoomScale = this.clampNum(Number((this.zoomScale - 0.25).toFixed(2)), 0.5, 4);
      if (this.zoomScale <= 1) {
        this.zoomPanX = 0;
        this.zoomPanY = 0;
      }
    },
    resetZoom() {
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
    },
    toggleDblZoom() {
      if (this.zoomScale > 1) {
        this.resetZoom();
      } else {
        this.zoomScale = 2;
      }
    },
    handleWheelZoom(e) {
      const delta = e.deltaY < 0 ? 0.2 : -0.2;
      const nextScale = this.clampNum(Number((this.zoomScale + delta).toFixed(2)), 0.5, 4);
      this.zoomScale = nextScale;
      if (nextScale <= 1) {
        this.zoomPanX = 0;
        this.zoomPanY = 0;
      }
    },
    startDrag(e) {
      if (this.zoomScale <= 1) return;
      this.isDragging = true;
      this.dragStartX = e.clientX - this.zoomPanX;
      this.dragStartY = e.clientY - this.zoomPanY;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      this.zoomPanX = e.clientX - this.dragStartX;
      this.zoomPanY = e.clientY - this.dragStartY;
    },
    stopDrag() {
      this.isDragging = false;
    },
    handleKeyDown(e) {
      if (e.key === 'Escape') {
        this.closeZoomModal();
      } else if (e.key === '+' || e.key === '=') {
        this.zoomIn();
      } else if (e.key === '-') {
        this.zoomOut();
      } else if (e.key === '0') {
        this.resetZoom();
      }
    },
    getCoverUrl(path) {
      const defaultPlaceholder =
        "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      if (!path || typeof path !== 'string') return defaultPlaceholder;
      if (
        path.startsWith('http://') ||
        path.startsWith('https://') ||
        path.startsWith('data:') ||
        path.startsWith('blob:')
      ) {
        return path;
      }
      if (!path.includes('/') && !path.includes('\\') && !path.includes(':')) {
        return 'data:image/jpeg;base64,' + path;
      }

      let cleanPath = path.replace(/\\/g, '/');
      if (cleanPath.includes('oldbooks/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('oldbooks/'));
      } else if (cleanPath.includes('cover/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('cover/'));
      } else if (cleanPath.includes('storge/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('storge/'));
      }
      cleanPath = cleanPath.replace(/^[A-Za-z]:/, '').replace(/^\/+/, '');

      const apiServiceUrl = process.env.VUE_APP_API_SERVICE_URL || process.env.VUE_APP_API_URL || '';
      const apiHost = apiServiceUrl.replace(/\/api\/?$/, '').replace(/\/+$/, '');

      if (apiHost) {
        return `${apiHost}/${cleanPath}`;
      }
      return `/${cleanPath}`;
    },
    handleImageError(event) {
      if (event && event.target) {
        event.target.onerror = null;
        event.target.src =
          "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      }
    },
    formatPrice(price) {
      if (!price && price !== 0) return '0 đ';
      return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
    },
    formatWeight(grams) {
      if (!grams || grams <= 0) return '0g';
      if (grams >= 1000) {
        return (grams / 1000).toFixed(1).replace('.0', '') + ' kg';
      }
      return grams + 'g';
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString('vi-VN');
    },
    getConditionLabel(verStatus) {
      const conditions = {
        0: 'Rất mới (95-100%)',
        1: 'Như mới (85-94%)',
        2: 'Khá mới (70-84%)',
        3: 'Trung bình (50-69%)',
        4: 'Cũ (< 50%)'
      };
      return conditions[verStatus] || 'Khác';
    },
    getListingStatusLabel(status) {
      const statuses = {
        0: 'Đang bán',
        1: 'Đã nhận cọc',
        2: 'Đã bán',
        3: 'Tạm ngưng',
        4: 'Đã hủy'
      };
      return statuses[status] !== undefined ? statuses[status] : 'Đang bán';
    }
  }
};
